import BossModel from "@/models/BossModel";
import Airline from "@/models/Airline/Airline";

export default class Target extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'airline/target';

    /**
     *
     * @type {string}
     */
    static entity = 'airlineTargets';

    static fields() {
        return {
            id: this.number(null).nullable(),
            airline_id: this.number(null).nullable(),
            include_purchase_tax: this.boolean(null),
            start_period: this.attr(null),
            end_period: this.attr(null),
            target: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            Airline: this.belongsTo(Airline, 'airline_id'),
        }
    }
}
